export default __webpack_public_path__ + "static/TechoMap-4cc012b78f9717162f3cf29ac2bb4607.png";